module.exports = __webpack_public_path__ + "img/edit-icon.620a99f2.svg";